import { connect } from "react-redux";
import { actions } from "primarycare-binder";
import withRouter from "../../../hoc/withRouter";
import withAllContexts from "../../../hoc/withAllContexts";
import Previous from "./previous";
import ToAttend from "./toAttend";
import UpNext from "./upNext";
import PauseButton from "../../../assets/img/svg/icons8-pause-button.svg";
import RepeatIcon from "../../../assets/img/svg/icons8-repeat.svg";
import ChangeUser from "../../../assets/img/svg/icons8-change-user.svg";

const PatientQueue = (props) => {
  const { parent_id, markHighPriority, assignReassignPractitioner } = props;

  let previousPatientList = props.previous;
  let toAttendPatientList = props.attend;
  let upNextPatientList = props.next;

  // previousPatientList = [
  //   {
  //     title: "Previous",
  //     token: "238",
  //     profile_pic:
  //       "https://st4.depositphotos.com/4329009/19956/v/600/depositphotos_199564354-stock-illustration-creative-vector-illustration-default-avatar.jpg",
  //     name: "Mohamed Idhris ",
  //     consultationMode: "Direct Consultation",
  //     role_: "frontdesk",
  //     role: "Consultation",
  //     start: "08:00 am",
  //   },
  // ];

  // toAttendPatientList = [
  //   {
  //     "resourcerole": {
  //         "display": "nephrologistdoctor",
  //         "_id": "CodingMaster/10216"
  //     },
  //     "inputdoc": {
  //         "resourcerole": "CodingMaster/10216",
  //         "slotdetails": {
  //             "appointmentType": "CodingMaster/11384",
  //             "slot_id": "Slot/1951876",
  //             "bookedcount": 0,
  //             "start": 1721266200,
  //             "walkinbookedcount": 3,
  //             "end": 1721280600,
  //             "status": "CodingMaster/11360"
  //         },
  //         "facilityid": "Organization/10138",
  //         "patientid": "Patient/10980",
  //         "referralid": "",
  //         "resourcecode": "Practitioner/10428",
  //         "shift": "",
  //         "appno": "AP-8207",
  //         "billhdrid": "",
  //         "appstatus": "CodingMaster/11362",
  //         "encounterid": "Encounter/12146",
  //         "resourcetype": "CodingMaster/10047",
  //         "encounterstatus": "CodingMaster/10808",
  //         "appointmentid": "Appointment/21799",
  //         "dialysismachine": "",
  //         "tenantid": "1234",
  //         "personid": "Person/17127",
  //         "consultationmode": "CodingMaster/10167",
  //         "scenario_type": "CodingMaster/11380",
  //         "appointmenttype": [
  //             "CodingMaster/12718"
  //         ]
  //     },
  //     "date": 1721266200,
  //     "queueid": "queue/10018",
  //     "queueMetaData": {
  //         "queuename": {
  //             "queuename": "Appointment Queue"
  //         },
  //         "userAction": {
  //             "userAction": ""
  //         },
  //         "inputSchema": {
  //             "inputSchema": ""
  //         },
  //         "entityKey": "appointmentSchema",
  //         "action": {
  //             "action": ""
  //         },
  //         "scenarioname": {
  //             "scenarioname": "Doctor Scenario"
  //         },
  //         "states": {
  //             "states": "Pending Doctor Signoff"
  //         }
  //     },
  //     "statesid": "queuestates/10054",
  //     "field11": "Encounter/12146",
  //     "field1": "Mansour Al Dohk",
  //     "field10": "Nephrology Medical Consultation",
  //     "field7": "Triaged",
  //     "name": "Mansour Al Dohk",
  //     "field6": "AP-8207",
  //     "action": [
  //         {
  //             "bgcolor": "",
  //             "icon": "<svg fill='#000000' xmlns='http://www.w3.org/2000/svg' width='800px' height='800px' viewBox='0 0 100 100' enable-background='new 0 0 100 100' xml:space='preserve'><path d='M30,58c-1.1,0-2-0.9-2-2v-2c0-1.1,0.9-2,2-2h20c0.5,0,0.9,0.2,1.3,0.5C54.5,49,59,46.6,64,46.1V26c0-3.3-2.7-6-6-6H26c-3.3,0-6,2.7-6,6v34c0,3.3,2.7,6,6,6h20c0-2.8,0.6-5.5,1.7-8H30z M28,30c0-1.1,0.9-2,2-2h20c1.1,0,2,0.9,2,2v2c0,1.1-0.9,2-2,2H30c-1.1,0-2-0.9-2-2V30z M28,42c0-1.1,0.9-2,2-2h24c1.1,0,2,0.9,2,2v2c0,1.1-0.9,2-2,2H30c-1.1,0-2-0.9-2-2V42z'/><path d='M66,52c-7.7,0-14,6.3-14,14s6.3,14,14,14s14-6.3,14-14S73.7,52,66,52z M73.9,62.5c0,0-8.9,9.7-8.9,9.7c-0.4,0.4-0.8,0.6-1.4,0.6c-0.5,0-1-0.2-1.4-0.6l-4.8-4.7c-0.4-0.4-0.4-1,0-1.3l1.4-1.3c0.4-0.4,1-0.4,1.4,0l3.4,3.4l7.5-8.4c0.4-0.4,1-0.4,1.4,0l1.4,1.3C74.2,61.5,74.2,62.2,73.9,62.5z'/></svg>",
  //             "textcolor": "",
  //             "action": "DOCTOR SIGNOFF",
  //             "actionid": "AC97",
  //             "_id": "queuestatesaction/10100",
  //             "backEndCall": false,
  //             "apiendpoint": "",
  //             "primaryaction": false
  //         },
  //         {
  //             "bgcolor": "",
  //             "icon": "<svg fill='#000000' width='800px' height='800px' viewBox='0 0 1000 1000' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'  enable-background='new 0 0 1000 1000' xml:space='preserve'><g><g transform='translate(0.000000,511.000000) scale(0.100000,-0.100000)'><path d='M6922,4570.4l-756.5-439.6l4-877.2l5.9-877.2l752.5-435.6c439.6-253.5,764.3-429.7,782.2-421.8c15.9,5.9,362.4,202,768.3,435.6l736.6,427.7v875.2v875.2l-762.4,439.6C8034.8,4814,7688.3,5012,7686.3,5010C7682.3,5010,7339.8,4812,6922,4570.4z M8290.3,4281.3l578.2-336.6l6-681.2l3.9-683.2l-584.2-338.6c-322.7-186.1-594.1-338.6-604-338.6c-7.9,0-279.2,152.5-602,338.6l-586.1,338.6v679.2v679.2l580.2,336.6c316.8,186.1,590.1,338.6,604,338.6C7698.2,4615.9,7971.5,4465.4,8290.3,4281.3z'/><path d='M7531.8,3497.1v-504.9h336.6h338.6l-5.9,164.4l-6,162.4l-162.4,5.9l-164.4,5.9l-3.9,330.7l-6,330.7l-162.4,5.9l-164.4,5.9V3497.1z'/><path d='M3809.1,3806l-326.7-190.1l-5.9-411.9c-2-225.8-7.9-409.9-11.9-409.9c-4,0-77.2,39.6-162.4,89.1c-87.1,49.5-164.4,89.1-176.2,89.1c-9.9,0-162.4-83.2-336.6-184.2L2472.4,2604l-5.9-1768.3c-2-972.3-11.9-1762.4-21.8-1756.4c-7.9,6-126.7,202-261.4,437.6L1937.8-57.3h-390.1h-388.1L967.5-386.1C862.5-568.2,779.4-730.6,785.3-748.4c4-17.8,156.4-287.1,336.6-600l328.7-570.3l99-477.2l97-479.2l576.2-576.2l576.2-576.2v-382.2V-4790h168.3h168.3v449.5v451.5l-588.1,588.1l-586.1,586.1l-97,461.4l-97,461.4l-306.9,530.7l-304.9,528.7l93.1,168.3l95,170.3h198h200l503-873.3c277.2-481.2,514.9-889.1,528.7-906.9c19.8-25.7,23.8,443.6,25.7,2275.2V2408l166.3,95l164.4,95.1l166.3-97l166.3-95.1l5.9-1400l4-1400h168.3h168.3V1513v1906.9l168.3,95l168.3,95.1l168.3-97l168.3-95V1513V-393.9h168.3H4819v1402v1400l170.3,95l168.3,95.1l166.3-95.1l166.3-95l2-1400v-1402h168.3h168.3v166.3v166.3l134.7,77.2c223.7,134.7,194,130.7,370.3,27.7l158.4-95l6-1039.6l3.9-1039.6l-336.6-897l-336.6-897v-431.7V-4790h168.3h168.3v400v398l336.6,899l336.6,897v1166.3V136.7l-301,174.2C6371.4,406,6221,493.2,6203.1,503.1c-25.8,15.8-71.3-2-190.1-71.3c-87.1-51.5-164.4-93.1-170.3-93.1c-7.9,0-15.9,508.9-17.8,1130.7l-6,1130.7l-316.8,186.1c-174.2,101-326.7,184.1-338.6,186.1c-13.9,0-93.1-39.6-178.2-89.1l-156.4-89.1l-9.9,409.9l-9.9,409.9l-267.3,154.5c-146.5,85.1-299,172.3-336.6,192.1l-69.3,35.7L3809.1,3806z'/></g></g></svg>",
  //             "textcolor": "",
  //             "action": "ON HOLD",
  //             "actionid": "AC98",
  //             "_id": "queuestatesaction/10101",
  //             "backEndCall": false,
  //             "apiendpoint": "",
  //             "primaryaction": false
  //         }
  //     ],
  //     "primaryAction":{
  //       "bgcolor": "",
  //       "icon": "<svg fill='#000000' xmlns='http://www.w3.org/2000/svg' width='800px' height='800px' viewBox='0 0 100 100' enable-background='new 0 0 100 100' xml:space='preserve'><path d='M30,58c-1.1,0-2-0.9-2-2v-2c0-1.1,0.9-2,2-2h20c0.5,0,0.9,0.2,1.3,0.5C54.5,49,59,46.6,64,46.1V26c0-3.3-2.7-6-6-6H26c-3.3,0-6,2.7-6,6v34c0,3.3,2.7,6,6,6h20c0-2.8,0.6-5.5,1.7-8H30z M28,30c0-1.1,0.9-2,2-2h20c1.1,0,2,0.9,2,2v2c0,1.1-0.9,2-2,2H30c-1.1,0-2-0.9-2-2V30z M28,42c0-1.1,0.9-2,2-2h24c1.1,0,2,0.9,2,2v2c0,1.1-0.9,2-2,2H30c-1.1,0-2-0.9-2-2V42z'/><path d='M66,52c-7.7,0-14,6.3-14,14s6.3,14,14,14s14-6.3,14-14S73.7,52,66,52z M73.9,62.5c0,0-8.9,9.7-8.9,9.7c-0.4,0.4-0.8,0.6-1.4,0.6c-0.5,0-1-0.2-1.4-0.6l-4.8-4.7c-0.4-0.4-0.4-1,0-1.3l1.4-1.3c0.4-0.4,1-0.4,1.4,0l3.4,3.4l7.5-8.4c0.4-0.4,1-0.4,1.4,0l1.4,1.3C74.2,61.5,74.2,62.2,73.9,62.5z'/></svg>",
  //       "textcolor": "",
  //       "action": "DOCTOR SIGNOFF",
  //       "actionid": "AC97",
  //       "_id": "queuestatesaction/10100",
  //       "backEndCall": false,
  //       "apiendpoint": "",
  //       "primaryaction": false
  //     },
  //     "secondaryAction":{
  //       "bgcolor": "",
  //       "icon": "<svg fill='#000000' width='800px' height='800px' viewBox='0 0 1000 1000' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'  enable-background='new 0 0 1000 1000' xml:space='preserve'><g><g transform='translate(0.000000,511.000000) scale(0.100000,-0.100000)'><path d='M6922,4570.4l-756.5-439.6l4-877.2l5.9-877.2l752.5-435.6c439.6-253.5,764.3-429.7,782.2-421.8c15.9,5.9,362.4,202,768.3,435.6l736.6,427.7v875.2v875.2l-762.4,439.6C8034.8,4814,7688.3,5012,7686.3,5010C7682.3,5010,7339.8,4812,6922,4570.4z M8290.3,4281.3l578.2-336.6l6-681.2l3.9-683.2l-584.2-338.6c-322.7-186.1-594.1-338.6-604-338.6c-7.9,0-279.2,152.5-602,338.6l-586.1,338.6v679.2v679.2l580.2,336.6c316.8,186.1,590.1,338.6,604,338.6C7698.2,4615.9,7971.5,4465.4,8290.3,4281.3z'/><path d='M7531.8,3497.1v-504.9h336.6h338.6l-5.9,164.4l-6,162.4l-162.4,5.9l-164.4,5.9l-3.9,330.7l-6,330.7l-162.4,5.9l-164.4,5.9V3497.1z'/><path d='M3809.1,3806l-326.7-190.1l-5.9-411.9c-2-225.8-7.9-409.9-11.9-409.9c-4,0-77.2,39.6-162.4,89.1c-87.1,49.5-164.4,89.1-176.2,89.1c-9.9,0-162.4-83.2-336.6-184.2L2472.4,2604l-5.9-1768.3c-2-972.3-11.9-1762.4-21.8-1756.4c-7.9,6-126.7,202-261.4,437.6L1937.8-57.3h-390.1h-388.1L967.5-386.1C862.5-568.2,779.4-730.6,785.3-748.4c4-17.8,156.4-287.1,336.6-600l328.7-570.3l99-477.2l97-479.2l576.2-576.2l576.2-576.2v-382.2V-4790h168.3h168.3v449.5v451.5l-588.1,588.1l-586.1,586.1l-97,461.4l-97,461.4l-306.9,530.7l-304.9,528.7l93.1,168.3l95,170.3h198h200l503-873.3c277.2-481.2,514.9-889.1,528.7-906.9c19.8-25.7,23.8,443.6,25.7,2275.2V2408l166.3,95l164.4,95.1l166.3-97l166.3-95.1l5.9-1400l4-1400h168.3h168.3V1513v1906.9l168.3,95l168.3,95.1l168.3-97l168.3-95V1513V-393.9h168.3H4819v1402v1400l170.3,95l168.3,95.1l166.3-95.1l166.3-95l2-1400v-1402h168.3h168.3v166.3v166.3l134.7,77.2c223.7,134.7,194,130.7,370.3,27.7l158.4-95l6-1039.6l3.9-1039.6l-336.6-897l-336.6-897v-431.7V-4790h168.3h168.3v400v398l336.6,899l336.6,897v1166.3V136.7l-301,174.2C6371.4,406,6221,493.2,6203.1,503.1c-25.8,15.8-71.3-2-190.1-71.3c-87.1-51.5-164.4-93.1-170.3-93.1c-7.9,0-15.9,508.9-17.8,1130.7l-6,1130.7l-316.8,186.1c-174.2,101-326.7,184.1-338.6,186.1c-13.9,0-93.1-39.6-178.2-89.1l-156.4-89.1l-9.9,409.9l-9.9,409.9l-267.3,154.5c-146.5,85.1-299,172.3-336.6,192.1l-69.3,35.7L3809.1,3806z'/></g></g></svg>",
  //       "textcolor": "",
  //       "action": "ON HOLD",
  //       "actionid": "AC98",
  //       "_id": "queuestatesaction/10101",
  //       "backEndCall": false,
  //       "apiendpoint": "",
  //       "primaryaction": false
  //     },
  //     "personid": "Person/17127",
  //     "field8": 1721266200,
  //     "consultationmode": {
  //         "display": "DIRECT",
  //         "_id": "CodingMaster/10167"
  //     },
  //     "field3": "63 Years",
  //     "field2": "MRN00_980",
  //     "field5": 8210,
  //     "ticketId": "T14131",
  //     "field4": "Male"
  // },
  // ];

  // upNextPatientList = [
  //   {
  //     title: "Up Next",
  //     token: "253",
  //     profile_pic:
  //       "https://fileupload.uat.ainqaplatform.in:443/pc_dialysis/12219",
  //     name: "AAliya Theoder ",
  //     role: "Consultation",
  //     encounter: "",
  //     consultationMode: "Direct Consultation",
  //     isEmergency: false,
  //     start: "08:00 pm",
  //     assignButtonIcon: ChangeUser,
  //     assigned: false,
  //     role_: "frontdesk",
  //     totalData: {
  //       appointmentType: "walkin",
  //       consultationMode: "Direct Consultation",
  //       token: 253,
  //       comment: "Checked-In",
  //       name: "AAliya Theoder ",
  //       isPatient: true,
  //       personId: 1563,
  //       patient_id: "Person/11569",
  //       patientId: 1358,
  //       pId: "Patient/11399",
  //       mrn: "MRN00_233",
  //       role: "Consultation",
  //       encounter: "",
  //       encounter_id: "",
  //       encounter_status: "",
  //       encounterId: "",
  //       showBringtoTop: true,
  //       profile_pic:
  //         "https://fileupload.uat.ainqaplatform.in:443/pc_dialysis/12219",
  //       isEmergency: false,
  //       start: "08:00 pm",
  //       startTime: 1694097000,
  //       info: {
  //         AppointmentNotification: [
  //           {
  //             practitionerEmail: "",
  //             mobile: "+91908763678",
  //             patientEmail: "",
  //           },
  //         ],
  //         Description: "string",
  //         Healthservice: [],
  //         Person: [
  //           {
  //             Id: 1563,
  //             OrgID: [],
  //             Patient: [
  //               {
  //                 OrgID: "",
  //                 PractitionerID: [],
  //                 _id: "Patient/11399",
  //                 _key: "11399",
  //                 _rev: "_gk7MMpC--I",
  //                 active: true,
  //                 activereason: "",
  //                 activestatus: true,
  //                 address: [],
  //                 age: "18",
  //                 age_type: "CodingMaster/10241",
  //                 alias: "MRN00_233",
  //                 approxAgeEntered: false,
  //                 attachment: [],
  //                 birthDate: "01/09/2005",
  //                 birthGendercode: "",
  //                 birthPlace: "",
  //                 birthTime: 0,
  //                 bloodGroup: "",
  //                 cadavericDonor: false,
  //                 citizenshipCode: "",
  //                 communicationLanguage: [],
  //                 conditionhistory: [],
  //                 createdby: "",
  //                 createddate: 1694084292,
  //                 deceaseddate: 0,
  //                 deceasedreason: "",
  //                 disabilityCode: "",
  //                 ethinicityCode: "",
  //                 gender: "CodingMaster/10267",
  //                 genderIdentitycode: "",
  //                 id: 1358,
  //                 identifier: ["IdentifierMaster/15730"],
  //                 isdeceased: "",
  //                 link: [
  //                   {
  //                     patient: [],
  //                     Type: "",
  //                   },
  //                 ],
  //                 maritalstatus: "",
  //                 name: ["HumanNameMaster/15400"],
  //                 nationality: "SMGeographicMaster/10035",
  //                 patientImp_Code: "",
  //                 patientTypecode: "",
  //                 personID: 1563,
  //                 photo: [
  //                   {
  //                     _key: "11818",
  //                     _id: "AttachmentMaster/11818",
  //                     _rev: "_gk7MMpC--C",
  //                     fileid: "12219",
  //                     filetype: "image/jpeg",
  //                     objectid: "11",
  //                     fileName:
  //                       "customer-service-cute-girl-white-shirt-with-red-lipstick-laptop-smiling-holding-pen.jpg",
  //                     id: 1329,
  //                     createdby: "",
  //                     createddate: 1694084292,
  //                     updatedby: "",
  //                     updatedate: 1694084292,
  //                     activestatus: true,
  //                     collection_name: "AttachmentMaster",
  //                   },
  //                 ],
  //                 preferredLanguage: "",
  //                 primarycare_Prac: "",
  //                 raceCode: "",
  //                 religionCode: "",
  //                 residencyStatus: false,
  //                 specialArng_code: "",
  //                 specialCourtesy_code: "",
  //                 statushistory: [
  //                   {
  //                     oldstatus: "",
  //                     oldstatusreason: "",
  //                     newstatus: "Active",
  //                     fromperiod: 1694084286,
  //                     toperiod: 0,
  //                   },
  //                 ],
  //                 telecom: [
  //                   "ContactPointMaster/20335",
  //                   "ContactPointMaster/20336",
  //                 ],
  //                 updatedate: 1694084512,
  //                 updatedby: "",
  //               },
  //             ],
  //             RelatedPersonID: [],
  //             _id: "Person/11569",
  //             _key: "11569",
  //             _rev: "_gk7MMfC---",
  //             active: true,
  //             activestatus: true,
  //             address: [],
  //             alias: "PER00_1227",
  //             birthDay: "01/09/2005",
  //             createdby: "",
  //             createddate: 1694084290,
  //             gender: "MALE",
  //             identifier: [],
  //             link: [],
  //             name: ["HumanNameMaster/15401"],
  //             photo: [
  //               {
  //                 _key: "11819",
  //                 _id: "AttachmentMaster/11819",
  //                 _rev: "_gk7MMf---K",
  //                 fileName:
  //                   "customer-service-cute-girl-white-shirt-with-red-lipstick-laptop-smiling-holding-pen.jpg",
  //                 fileid: "12219",
  //                 filetype: "image/jpeg",
  //                 objectid: "11",
  //                 id: 1330,
  //                 createdby: "",
  //                 createddate: 1694084512,
  //                 updatedby: "",
  //                 updatedate: 1694084512,
  //                 activestatus: true,
  //               },
  //             ],
  //             telecom: [
  //               {
  //                 _key: "20337",
  //                 _id: "ContactPointMaster/20337",
  //                 _rev: "_gk7MMf---G",
  //                 system: "Phone",
  //                 value: "+91908763678",
  //                 use: "Mobile",
  //                 rank: "1",
  //                 period: ["periodMaster/71777"],
  //                 id: 7701,
  //                 createdby: "",
  //                 createddate: 1694084512,
  //                 updatedby: "",
  //                 updatedate: 1694084512,
  //                 activestatus: true,
  //               },
  //               {
  //                 _key: "20338",
  //                 _id: "ContactPointMaster/20338",
  //                 _rev: "_gk7MMf---I",
  //                 system: "Email",
  //                 value: "n@yopmail.com",
  //                 use: "Work",
  //                 rank: "2",
  //                 period: ["periodMaster/71778"],
  //                 id: 7702,
  //                 createdby: "",
  //                 createddate: 1694084512,
  //                 updatedby: "",
  //                 updatedate: 1694084512,
  //                 activestatus: true,
  //               },
  //             ],
  //             updatedate: 1694084512,
  //             updatedby: "",
  //             HumanName: [
  //               {
  //                 _id: "HumanNameMaster/15401",
  //                 _key: "15401",
  //                 _rev: "_gk7MMf---A",
  //                 activestatus: true,
  //                 createdby: "",
  //                 createddate: 1694084512,
  //                 family: "Theoder",
  //                 given: "",
  //                 id: 4628,
  //                 period: ["periodMaster/71776"],
  //                 prefix: "Mr",
  //                 suffix: null,
  //                 text: "AAliya",
  //                 updatedate: 1694084512,
  //                 updatedby: "",
  //                 use: null,
  //               },
  //             ],
  //           },
  //         ],
  //         PersonID: [1563],
  //         ServiceCategoryID: [],
  //         ServiceTypeID: [],
  //         SpecialtyID: [456],
  //         _id: "Appointment/13931",
  //         _key: "13931",
  //         _rev: "_gk7JgTW--E",
  //         activestatus: true,
  //         appno: "AP-253",
  //         appointmentReason: [],
  //         appointmentType: "walkin",
  //         appointmentTypeID: [],
  //         appstatus: "booked",
  //         avcpatientstatus: "YET TO LOGIN",
  //         basedOn: [],
  //         bookedby: "Practitioner/10008",
  //         cancelationReason: [],
  //         comment: "Checked-In",
  //         consultationMode: "Direct Consultation",
  //         createdby: "",
  //         createddate: 1694084335,
  //         encounter: [],
  //         end: 1694104200,
  //         id: 253,
  //         identifier: [],
  //         minutesDuration: 0,
  //         orgid: "",
  //         orgtype: "CodingMaster/10010",
  //         participant: [],
  //         patientInstruction: "",
  //         priority: 1,
  //         reasonCode: [],
  //         reasonReference: [],
  //         report_docs: [],
  //         requestedPeriod: ["periodMaster/71770"],
  //         resourcecode: "Practitioner/10008",
  //         resourcerole: "Physician ",
  //         resourcetype: "Practitioner",
  //         slotID: [3814760],
  //         start: 1694097000,
  //         status: true,
  //         supportingInformation: [],
  //         updatedate: 1694084335,
  //         updatedby: "",
  //         Practitioner: [],
  //       },
  //       mobileNo: "+91908763678",
  //       index: 5,
  //       status: true,
  //       type: "frontdesk",
  //     },
  //   },
  // ];

  return (
    <div
      id={`${parent_id}_queue_parent_div`}
      style={
        {
          // height: "100vh",
          // overflow: "hidden auto",
        }
      }
    >
      {previousPatientList && previousPatientList.map((item, i) => (
        <Previous parentid={parent_id} item={item} index={i} />
      ))}
      {toAttendPatientList &&
        toAttendPatientList?.map((item, i) => (
          <ToAttend item={item} index={i} 
          getTabData={props?.getTabData}
          selectedQueue={props?.selectedQueue}
          scenarioId={props?.scenarioId}></ToAttend>
        ))}
      {upNextPatientList &&
        upNextPatientList?.map((item, i) => (
          <UpNext item={item} index={i}
          getTabData={props?.getTabData}
          selectedQueue={props?.selectedQueue}
          scenarioId={props?.scenarioId}></UpNext>
        ))}
    </div>
  );
};

const mapStateToProps = (state) => ({
  loggedUserInfo: state?.authSlice?.loggedUserInfo,
});

export default connect(
  mapStateToProps,
  actions
)(withRouter(withAllContexts(PatientQueue)));
